import React from 'react'
import { ActionIcons } from '../model/enums'
import { AVAILABLE_ACTION_ICONS } from '../model/constants'
import { DataTableActionConfiguration, ActionIcon } from '../model'
import { generateUniqueKey } from './uniqueKeyHelper'
import { DataTableActionIcon } from '../components'

export const associateActionIcon = (
  item: any,
  icon?: ActionIcons,
  tooltip?: string,
  clickHandler?: Function,
  isLoading?: boolean,
  hasPermission?: boolean
): JSX.Element => {
  if (icon === undefined) {
    return <></>
  }
  return composeActionIcon(
    item,
    AVAILABLE_ACTION_ICONS.find(x => x.id === icon),
    tooltip,
    clickHandler,
    isLoading,
    hasPermission
  )
}

const composeActionIcon = (
  item: any,
  actionIcon: ActionIcon | undefined,
  tooltip?: string,
  clickHandler?: Function,
  isLoading?: boolean,
  hasPermission?: boolean
): JSX.Element => {
  if (actionIcon === undefined) {
    return <span key={generateUniqueKey('noicon')}>&nbsp;</span>
  }
  return (
    <DataTableActionIcon
      key={generateUniqueKey('dataTableIconAction')}
      item={item}
      tooltip={tooltip}
      actionIcon={actionIcon}
      clickHandler={clickHandler}
      isLoading={isLoading}
      hasPermission={hasPermission}
    ></DataTableActionIcon>
  )
}

export const generateIconsFromConfiguration = (
  item: any,
  actions: Array<DataTableActionConfiguration>,
  handlers: Map<number, Function | undefined>
): JSX.Element => {
  return (
    <div style={{ display: 'flex' }}>
      {actions?.map(configuration => {
        return associateActionIcon(
          item,
          configuration.icon,
          handlers.get(configuration.icon!) !== undefined && configuration.hasPermission === true
            ? configuration.tooltip
            : configuration.noHandlerTooltip !== undefined
              ? configuration.noHandlerTooltip
              : configuration.tooltip,
          handlers.get(configuration.icon!),
          configuration.isLoading,
          configuration.hasPermission
        )
      })}
    </div>
  )
}

export const changeActionIsLoading = (
  actionsConfiguration: DataTableActionConfiguration[] | undefined,
  icon: ActionIcons,
  isLoading: boolean
): DataTableActionConfiguration[] | undefined => {
  if (actionsConfiguration === undefined) return undefined
  return actionsConfiguration?.map(configuration => {
    if (configuration.icon === icon) {
      configuration.isLoading = isLoading
    }
    return configuration
  })
}
